<template>
  <div id="app">
    <!-- app.vue -->
    <router-view/>
    <!-- <first-component></first-component> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
    console.log(localStorage.token);
    if(localStorage.token == undefined || localStorage.token == null || localStorage.token == ''){
      this.$router.push({name:'Login'});
    }else{
      this.$router.push({name:'personmanage'});
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue